import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrainingQualificationCreateService {
  private _trainingQualificationCreateDrawerVisible =
    new ReplaySubject<boolean>(1);
  private _trainingQualificationCreatedQualifications = new Subject<void>();
  private _trainingQualificationDeleteQualifications = new Subject<void>();

  public trainingQualificationCreateDrawerVisible$ =
    this._trainingQualificationCreateDrawerVisible.asObservable();

  public trainingQualificationCreatedQualifications$ =
    this._trainingQualificationCreatedQualifications.asObservable();

  public trainingQualificationDeleteQualifications$ =
    this._trainingQualificationDeleteQualifications.asObservable();

  setTrainingQualificationCreateDrawerVisible(visible: boolean): void {
    this._trainingQualificationCreateDrawerVisible.next(visible);
  }

  triggerTrainingQualificationCreatedQualifications(): void {
    this._trainingQualificationCreatedQualifications.next();
  }

  triggerTrainingQualificationDeleteQualifications(): void {
    this._trainingQualificationDeleteQualifications.next();
  }

  resetDrawer(): void {
    this._trainingQualificationCreateDrawerVisible.next(false);
    this._trainingQualificationCreateDrawerVisible.next(true);
  }
}
